import { makeAutoObservable } from "mobx";

class UserStore {
    mobileNumbers = [];
    loggedIn = false;

    constructor() {
        makeAutoObservable(this);
    }

    addMobileNumber(number) {
        this.mobileNumbers.push(number);
    }

    getMobileNumbers() {
        return this.mobileNumbers;
    }
    userLogin(bool) {
        this.loggedIn = bool;
        //console.log("called");
    }
}

const userStore = new UserStore();
export default userStore;
